import React from 'react'
import { Section } from '../../components/Section'
import { SectionContentImageWithText } from '../../components/SectionContentImageWithText'
import { SiteLink } from '../../app-types'
import { ExternalGigproLinks, INTRASITE_LINKS } from '../../constants'

const links: SiteLink[] = [
  {
    id: 'mara-hero-post-a-shift',
    label: 'POST A SHIFT',
    variant: 'contained',
    page: null,
    pageSection: null,
    article: null,
    externalHref: ExternalGigproLinks.login,
  },
  {
    id: 'mara-hero-learn-how',
    label: 'LEARN HOW MARA WORKS',
    variant: 'contained',
    page: null,
    pageSection: null,
    article: null,
    internalHref: `${INTRASITE_LINKS.maraAi.pagePath}#how-it-works-for-businesses`,
  },
]

export const SectionContentInstanceMaraHero: React.FunctionComponent = () => (
  <Section backgroundColor="orange" padding={100} prerender>
    <SectionContentImageWithText
      subheading="Mara • AI MATCHING"
      heading="MEET MARA."
      headingComponent="h1"
      headingVariant="t1"
      description={{
        description:
          '## Qwick’s exclusive AI matching assistant, making every match feel like magic.✨\n\nBehind every filled shift is Mara — Qwick’s proprietary matching algorithm that connects hospitality businesses with the right professionals faster than traditional staffing and hiring ever could.',
      }}
      imagePlacement="right"
      image={{
        publicId: 'photography/image-mara-header-image',
        alt: 'Photo of a lady with text bubbles reading certified, reliable, experienced',
      }}
      links={links}
      showAppStoreLinks={false}
    />
  </Section>
)
